import React, { useEffect, useState } from 'react';
import { signInWithCustomToken } from 'firebase/auth';
import { auth } from '../firebase';
import { Typography, Box, CircularProgress } from '@mui/material';

const MobileAuthHandler = () => {
  const [status, setStatus] = useState('checking'); // checking, authenticating, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const handleMobileAuth = async () => {
      try {
        // Check URL parameters for custom token
        const urlParams = new URLSearchParams(window.location.search);
        const customToken = urlParams.get('token');

        if (!customToken) {
          setStatus('idle');
          return;
        }

        console.log('Mobile Auth: Found custom token in URL, authenticating...');
        setStatus('authenticating');
        setMessage('מאמת זהות ממכשיר נייד...');

        // Validate token format (basic check)
        if (customToken.length < 100) {
          throw new Error('Invalid token format');
        }

        // Sign in with the custom token
        const userCredential = await signInWithCustomToken(auth, customToken);
        
        console.log('Mobile Auth: Successfully authenticated with custom token', {
          uid: userCredential.user.uid,
          email: userCredential.user.email
        });

        setStatus('success');
        setMessage('התחברות הושלמה בהצלחה!');

        // Clean up URL parameters
        const newUrl = window.location.pathname;
        window.history.replaceState({}, document.title, newUrl);

        // Get intended destination or default to dashboard
        const intendedDestination = sessionStorage.getItem('intendedDestination') || '/c/dashboard';
        console.log('Mobile Auth: Intended destination:', intendedDestination);
        
        if (intendedDestination !== '/c/dashboard') {
          sessionStorage.removeItem('intendedDestination');
        }

        // Redirect to intended destination after a short delay
        setTimeout(() => {
          console.log('Mobile Auth: Redirecting to:', intendedDestination);
          window.location.href = intendedDestination;
        }, 1500);

      } catch (error) {
        console.error('Mobile Auth: Error during authentication:', error);
        setStatus('error');
        
        let errorMessage = 'שגיאה בהתחברות ממכשיר נייד';
        if (error.code === 'auth/invalid-custom-token') {
          errorMessage = 'טוקן לא תקין. אנא נסה שוב מהאפליקציה.';
        } else if (error.code === 'auth/custom-token-mismatch') {
          errorMessage = 'טוקן לא תואם. אנא נסה שוב.';
        } else if (error.message.includes('Invalid token format')) {
          errorMessage = 'פורמט טוקן לא תקין.';
        }
        
        setMessage(errorMessage);

        // Clean up URL parameters even on error
        const newUrl = window.location.pathname;
        window.history.replaceState({}, document.title, newUrl);

        // Redirect to login after delay
        setTimeout(() => {
          window.location.href = '/';
        }, 3000);
      }
    };

    handleMobileAuth();
  }, []);

  // Don't render anything if no token found
  if (status === 'idle') {
    return null;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="200px"
      p={3}
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        zIndex: 9999,
        backdropFilter: 'blur(5px)'
      }}
    >
      {(status === 'checking' || status === 'authenticating') && (
        <>
          <CircularProgress size={50} sx={{ mb: 2 }} />
          <Typography variant="h6" align="center" gutterBottom>
            {message}
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center">
            אנא המתן...
          </Typography>
        </>
      )}

      {status === 'success' && (
        <>
          <Box sx={{ fontSize: 48, mb: 2 }}>✅</Box>
          <Typography variant="h6" align="center" gutterBottom color="success.main">
            {message}
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center">
            מעביר לדשבורד...
          </Typography>
        </>
      )}

      {status === 'error' && (
        <>
          <Box sx={{ fontSize: 48, mb: 2 }}>❌</Box>
          <Typography variant="h6" align="center" gutterBottom color="error.main">
            {message}
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center">
            מעביר לעמוד הבית...
          </Typography>
        </>
      )}
    </Box>
  );
};

export default MobileAuthHandler; 